module.exports = __webpack_public_path__ + "img/Solar-Drying-Solutions-1110x450.c0ebc022.png";